import { render, staticRenderFns } from "./TitleListsManual.vue?vue&type=template&id=1dace530&"
import script from "./TitleListsManual.vue?vue&type=script&lang=js&"
export * from "./TitleListsManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports